/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input, FormGroup, Col, Label, Alert } from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Class to handle the username for group
 * It validates the username (check if username already exists)
 * And it validates the character length and more
 */
class FormGroupUsername extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validUsername: true,
            usernameAvailable: true,
            username: ''
        }; // Default value

        if(this.props.data)
        {
            this.state =
            {
                username: this.props.data.username,
                validUsername: true,
                usernameAvailable: true
            }; // Default value
        }
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        if(typeof nextProps.data !== 'undefined'){
            this.setState({
                username: nextProps.data.username
            });
        }
    }

    /**
     * Action when the username changes
     * @param event
     */
    handleChange(event) {
        this.setState({username: event.target.value, validUsername: Validator.isUsernameValid(event.target.value)},
            () => {

                if(this.state.validUsername){
                Validator.isUsernameAvailable(this.state.username,
                    (returned)=>
                    {
                        this.setState({usernameAvailable:returned});
                        // Verifies if username is available
                        this.props.updateParent(this.state);
                        return this.state;
                    })}
            });
         // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    renderError(){
        return (<div>
            <FormGroup row>
                <Col sm={{ size: 10, offset: 1 }}>
                    <Alert color="danger" isOpen={!this.state.validUsername}>
                        <Translate id="register.username-error" />
                    </Alert>
                    <Alert color="danger" isOpen={!this.state.usernameAvailable}>
                        <Translate id="register.username-availability-error" />
                    </Alert>
                </Col>
            </FormGroup>
        </div>)
    }

    // Render the form group
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="username">
                            <Translate id="register.username"/>
                        </Label>
                        <Input value={this.state.username} type="username" name="username" id="username" onChange={this.handleChange} />
                    </Col>
                </FormGroup>
                {!this.state.validUsername || !this.state.usernameAvailable ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validUsername}>
                                <Translate id="register.username-error" />
                            </Alert>
                            <Alert color="danger" isOpen={!this.state.usernameAvailable}>
                                <Translate id="register.username-availability-error" />
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
            </div>
        )
    };
}

export default FormGroupUsername;


// WEBPACK FOOTER //
// ./src/components/forms/form-group-username.js